import { TemplateState } from '../templateeditor-types';

export type TemplateMeta = {
  id: string;
  name: string;
};

export function getTemplateMeta(state: TemplateState): TemplateMeta {
  const { template } = state;

  return {
    id: template?.id || '',
    name: template?.name || ''
  };
}
